
// export const myGetter = ( state ) => {
//  return state
// }


export const currentState = ( state ) => {
    return state.status
}

export const username = ( state ) => {
    console.log( 'id getters')
    console.log( state.id)
    return state.id 
}